/**
 * HorizonHeader.tsx
 *
 * W66.C — Methodology Workspace
 * Shared header for each of the four horizon sections.
 * Em-dash label format. No exclamation points. No emojis.
 */

interface HorizonHeaderProps {
  /** Horizon number 1–4 */
  number: number;
  /** Short label after the em-dash */
  label: string;
  /** Optional sub-line */
  description?: string;
}

export default function HorizonHeader({ number, label, description }: HorizonHeaderProps) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: description ? 6 : 0 }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 28,
            height: 28,
            borderRadius: "50%",
            background: "#0B0B0F",
            color: "#FAFAF7",
            fontSize: 12,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {number}
        </span>
        <h2
          style={{
            margin: 0,
            fontSize: 18,
            fontWeight: 700,
            color: "#0B0B0F",
            letterSpacing: "-0.01em",
          }}
        >
          H{number} — {label}
        </h2>
      </div>
      {description && (
        <p style={{ margin: 0, fontSize: 13, color: "#6B6B70", lineHeight: 1.6, paddingLeft: 38 }}>
          {description}
        </p>
      )}
    </div>
  );
}
